export default __webpack_public_path__ + "static/celeb-33c7ec028303ca2d12f5b88fbebe0a0a.png";